import { useMemo } from "react";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { getPercent, sumFromList } from "../../../../../../services/utils";
import { ShaDowBox } from "../../../../../../components/boxes/ShadowBox";
import { BUILDING_STATUSES, STATUS_OB_READY } from "../../../../../../services/constants";
import { COLORS } from "../../../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  statusBox: {
    width: "fit-content",
    marginRight: theme.spacing(3),
  },
  statusCount: {
    marginLeft: theme.spacing(0.4),
    marginRight: theme.spacing(0.5),
  },
  statusName: {
    position: "relative",
    top: 2,
  },
}));

export const OnboardingProcess = ({ buildings, statusCount }) => {
  const classes = useStyles();
  const statusPercent = useMemo(() => {
    const percent = {};
    const totalBuildings = buildings.length;
    for (const k in statusCount) {
      percent[k] = +getPercent(statusCount[k], totalBuildings, 2);
    }
    return percent;
  }, [buildings, statusCount]);

  return (
    <ShaDowBox>
      <Box paddingX={4} pt={3.5} pb={2.5}>
        <Typography variant="h4">
          {(sumFromList(Object.values(statusPercent)) - statusPercent[STATUS_OB_READY]).toFixed(2)}%
          of your portfolio buildings have started the OB process
        </Typography>

        <Box
          display="flex"
          width={920}
          height={30}
          marginY={2.25}
          maxWidth="100%"
          bgcolor={COLORS.darks[0][3]}
        >
          {Object.entries(BUILDING_STATUSES).map(([statusKey, status], i) => (
            <Box key={i} width={statusPercent[statusKey] + "%"} bgcolor={status.color} />
          ))}
        </Box>

        <Grid container alignItems="center">
          {Object.entries(BUILDING_STATUSES).map(([statusKey, status], i) => (
            <Grid className={classes.statusBox} container key={i} alignItems="center">
              <Box width={8} height={8} bgcolor={status.color} />
              <Typography className={classes.statusCount} variant="h3">
                {statusCount[statusKey]}
              </Typography>
              <Typography className={classes.statusName} variant="body2">
                {status.name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
